import { Action, createReducer, on } from '@ngrx/store';
import { fromSendTaxCertificateActions } from '../actions';
import { IGenericError, ErrorResponse } from 'src/app/core/models/generic-models';

export const sendTaxCertFeatureKey = 'sendTaxCert';

export interface sendTaxCertState {
  sendTaxCertRequest: any;
  sendTaxCertResponse: string;
  sendTaxCertFailure: IGenericError<ErrorResponse>;
}

export const initialState: sendTaxCertState = {
  sendTaxCertRequest: undefined,
  sendTaxCertResponse: undefined,
  sendTaxCertFailure: undefined
};

export const reducer = createReducer(
  initialState,

  on(fromSendTaxCertificateActions.loadSendTaxCertificates, (state, action) => ({
    ...state,
    sendTaxCertRequest: action.requestData
  })),
  on(fromSendTaxCertificateActions.loadSendTaxCertificatesSuccess, (state, action) => ({
    ...state,
    sendTaxCertResponse: action.response
  })),
  on(fromSendTaxCertificateActions.loadSendTaxCertificatesFailure, (state, action) => ({
    ...state,
    sendTaxCertFailure: action.error
  }))
);

export const sendTaxRequest = (state: sendTaxCertState) => state.sendTaxCertRequest;
export const sendTaxResponse = (state: sendTaxCertState) => {
  return state.sendTaxCertResponse;
};
export const sendTaxFailure = (state: sendTaxCertState) => state.sendTaxCertFailure;
